/**
 * Type-2 service carousel shared by the front page, the services page and the competence center.
 * Owl options, including the 1 / 2 / 4 / 5 card counts, come from data-slider-options.
 */
(function ($) {
    'use strict';

    const measureServiceExcerptHeight = ($excerpt) => {
        const excerptEl = $excerpt.get(0);

        if (!excerptEl) {
            return 0;
        }

        const previousTransition = excerptEl.style.transition;

        excerptEl.style.transition = 'none';
        $excerpt.css('height', 'auto');
        const targetHeight = $excerpt.height();
        $excerpt.height(0);
        excerptEl.offsetHeight;
        excerptEl.style.transition = previousTransition;

        return targetHeight;
    };

    const initServiceExcerptHover = ($slider) => {
        $slider.off('mouseenter.techkormExcerpt mouseleave.techkormExcerpt', '.techkorm-services__card');
        $slider.on('mouseenter.techkormExcerpt', '.techkorm-services__card', function () {
            const $excerpt = $(this).find('.service-item-excerpt');

            if (!$excerpt.length) {
                return;
            }

            const targetHeight = measureServiceExcerptHeight($excerpt);

            if (targetHeight > 0) {
                $excerpt.height(targetHeight);
            }
        });
        $slider.on('mouseleave.techkormExcerpt', '.techkorm-services__card', function () {
            $(this).find('.service-item-excerpt').height(0);
        });
    };

    const refreshServicesCarousel = () => {
        $('.techkorm-services-carousel.owl-loaded').each(function () {
            $(this).trigger('refresh.owl.carousel');
        });
    };

    const initServicesCarousel = () => {
        const $sliders = $('.techkorm-services-carousel.owl-carousel');

        if (!$sliders.length || typeof $.fn.owlCarousel !== 'function') {
            return;
        }

        $sliders.each(function () {
            const $slider = $(this);

            if ($slider.hasClass('owl-loaded')) {
                return;
            }

            const options = $slider.data('sliderOptions') || {};
            const dotsContainer = options.dotsContainer || '.owl-dots-techkorm-services';

            $slider.owlCarousel($.extend(true, {}, options, {
                dotsContainer: dotsContainer,
                onInitialized: function () {
                    $slider.addClass('techkorm-services-carousel--ready');
                    $slider.closest('.techkorm-services__inner').addClass('techkorm-services--ready');
                    initServiceExcerptHover($slider);
                    window.requestAnimationFrame(refreshServicesCarousel);
                },
            }));
        });
    };

    $(document).ready(initServicesCarousel);

    $(window).on('load.techkormServicesCarousel', refreshServicesCarousel);

    let techkormServicesResizeTimer;

    $(window).on('resize.techkormServicesCarousel', () => {
        window.clearTimeout(techkormServicesResizeTimer);
        techkormServicesResizeTimer = window.setTimeout(refreshServicesCarousel, 150);
    });
})(jQuery);
